module.exports = __webpack_public_path__ + "fonts/SFUIText-RegularItalic.02a6e790.ttf";